import { render, staticRenderFns } from "./jdpayDetail.vue?vue&type=template&id=383b5fb4&scoped=true&"
import script from "./jdpayDetail.vue?vue&type=script&lang=js&"
export * from "./jdpayDetail.vue?vue&type=script&lang=js&"
import style0 from "./jdpayDetail.vue?vue&type=style&index=0&id=383b5fb4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "383b5fb4",
  null
  
)

export default component.exports